import { render, staticRenderFns } from "./quote-card.vue?vue&type=template&id=ee1540c0&scoped=true"
import script from "./quote-card.vue?vue&type=script&lang=js"
export * from "./quote-card.vue?vue&type=script&lang=js"
import style0 from "./quote-card.vue?vue&type=style&index=0&id=ee1540c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1540c0",
  null
  
)

export default component.exports